import { useState, useEffect, useCallback } from 'react';
import { fetchSubscriptionStatus } from './api';
import { isLoggedIn } from './auth';

export function useSubscription() {
  const [plan,          setPlan]     = useState('free');
  const [status,        setStatus]   = useState('active');
  const [interval,      setInterval2] = useState('month');
  const [periodEnd,     setPeriodEnd] = useState('');
  const [loading,       setLoading]  = useState(true);

  const refresh = useCallback(async () => {
    if (!isLoggedIn()) { setLoading(false); return; }
    try {
      const data = await fetchSubscriptionStatus();
      setPlan(data.plan         || 'free');
      setStatus(data.status     || 'active');
      setInterval2(data.interval || 'month');
      setPeriodEnd(data.currentPeriodEnd || '');
    } catch {
      setPlan('free');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const isPro = plan === 'pro' && status === 'active';

  return { plan, status, interval, periodEnd, isPro, loading, refresh };
}